import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ru from './locales/ru.json';
import en from './locales/en.json';

// SSR creates a separate instance for every request; never share its language.
export function createI18n(locale = 'ru') {
    const instance = i18next.createInstance();
    instance.use(initReactI18next).init({
        resources: { ru: { translation: ru }, en: { translation: en } },
        lng: locale,
        fallbackLng: 'en',
        initAsync: false,
        interpolation: { escapeValue: false },
    });
    return instance;
}

export default createI18n();
